'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dotstatsuiteVisions = require('@sis-cc/dotstatsuite-visions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(_ref) {
  var target = _ref.target,
      props = (0, _objectWithoutProperties3.default)(_ref, ['target']);
  return _react2.default.createElement(
    'div',
    target ? { ref: target } : {},
    _react2.default.createElement(_dotstatsuiteVisions.DataHeader, props)
  );
};

exports.default = Header;